<template>
    <a-card>
    <h3 style="text-align: center;margin:20px 0 40px">单位基本信息</h3>
        <a-descriptions size="middle" :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }" bordered={true}>
            <a-descriptions-item label="单位名称" name="unitName">{{form.unitName}}</a-descriptions-item>
            <a-descriptions-item label="单位性质" name="unitNature">
				<dict-render :dict-obj="dictObjs['businessScope']" :text="form.unitNature" v-if="form.unitNature"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="组织机构代码" name="organizationCode">{{form.organizationCode}}</a-descriptions-item>
            <a-descriptions-item label="信用等级" name="creditLevel">
				<dict-render :dict-obj="dictObjs['creditLevel']" :text="form.creditLevel" v-if="form.creditLevel"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="法人代表" name="legaRepresentative">{{form.legaRepresentative}}</a-descriptions-item>
            <a-descriptions-item label="法人身份证号" name="corporateIdcard">{{form.corporateIdcard}}</a-descriptions-item>
            <a-descriptions-item label="法人手机号" name="corporatePhone">{{form.corporatePhone}}</a-descriptions-item>
            <a-descriptions-item label="法人邮箱" name="corporateEmail">{{form.corporateEmail}}</a-descriptions-item>
            <a-descriptions-item label="开户银行" name="bankDeposit">{{form.bankDeposit}}</a-descriptions-item>
            <a-descriptions-item label="开户行号" name="openingBankNumber">{{form.openingBankNumber}}</a-descriptions-item>
            <a-descriptions-item label="开户名称" name="accountName">{{form.accountName}}</a-descriptions-item>
            <a-descriptions-item label="账户" name="account">{{form.account}}</a-descriptions-item>
            <a-descriptions-item label="职工总数" name="workforceNumber">{{form.workforceNumber}}</a-descriptions-item>
            <a-descriptions-item label="职工中高级人数" name="workforceLevelNumber">{{form.workforceLevelNumber}}</a-descriptions-item>
            <a-descriptions-item label="所在地" name="location">{{form.location}}</a-descriptions-item>
            <a-descriptions-item label="通讯地址" name="mailAddress">{{form.mailAddress}}</a-descriptions-item>
            <a-descriptions-item label="邮编" name="postalCode">{{form.postalCode}}</a-descriptions-item>
            <a-descriptions-item label="传真" name="fax">{{form.fax}}</a-descriptions-item>
            <a-descriptions-item label="联系人姓名" name="contactName">{{form.contactName}}</a-descriptions-item>
            <a-descriptions-item label="联系人电话" name="contactTelephone">{{form.contactTelephone}}</a-descriptions-item>
            <a-descriptions-item label="联系人手机号" name="contactPhone">{{form.contactPhone}}</a-descriptions-item>
            <a-descriptions-item label="联系人邮箱" name="contactEmail">{{form.contactEmail}}</a-descriptions-item>
            <a-descriptions-item label="注册地址" name="registeredAddress">{{form.registeredAddress}}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<script>

    import { projectUnit } from "@/api/TechnologieprojekteApply";
    import {
        dictMixin,
        formMixin
    } from "@/mixins";
    import DictRender from "@/components/other/DictRender";
    export default {
        name: "单位基本信息",
        mixins: [formMixin, dictMixin],
        components: {
            DictRender
        },
        data() {
            return {
                options: null,
                form:{
                    provject:null,
                },
                dictNames: "businessScope,creditLevel",
            }
        },

        mounted() {
            this.getData()
        },
        methods: {
            getData(){
                this.getAction({
                    url: projectUnit.detailByProject,
                    params: { 
                        projectId: this.$route.query.projectId,
                        classification: this.$route.query.classification,
                     }
                }).then((res) => {
                    if(res){
                        this.form = res
                    }
                });
            }
        }

    }
</script>
